import React from 'react';
import { Button } from "@blueprintjs/core";

import SequenceResourcesViewer from '../ResourceViewer/Sequence';

class SequencesMonitor extends React.Component {
    render() {
        const {
            sessionInstance,
            sequenceDisplayed,
            session,
            onSwitchResource,
            onPrevSequence,
            onFirstSequence,
            onNextSequence,
            onLastSequence,
            isNextDisabled,
            isPrevDisabled,
            protocol,
        } = this.props;
        const { data } = session;
        const { msCriterias = [] } = data;

        return (
            <div className="sequences-wrapper animated fadeIn">
                <div className="row resources">
                    <SequenceResourcesViewer
                        instance={sessionInstance}
                        sequenceDisplayed={sequenceDisplayed}
                        onSwitchResource={onSwitchResource} 
                        protocol={protocol}
                        />
                        
                </div>
                <div className="nav text-center">
                    <Button
                        icon='double-chevron-left'
                        onClick={onFirstSequence}
                        disabled={isPrevDisabled()}
                        style={{ marginRight: '5px' }} />
                    <Button
                        icon='chevron-left'
                        onClick={onPrevSequence}
                        disabled={isPrevDisabled()}
                        className="large-padding" />
                    <span className="pagination">
                        <span className="muted">
                            Sequence
                        </span>
                        &nbsp;{sessionInstance.currentSequence + 1}&nbsp;
                        <span className="muted">
                            of
                        </span>
                        &nbsp;{session.data.sequences.length}
                    </span>
                    <Button
                        rightIcon='chevron-right'
                        onClick={onNextSequence}
                        disabled={isNextDisabled()}
                        className="large-padding" />
                    <Button
                        rightIcon='double-chevron-right'
                        onClick={onLastSequence}
                        disabled={isNextDisabled()}
                        style={{ marginLeft: '5px' }} />
                </div>
                {(msCriterias && msCriterias.length) 
                    ?
                    <div className="ms-criterias ">
                        {msCriterias.map((c, index) => (
                        <li className="monitor-feed" key={index}>
                            {c.type} - {c.name} 
                            {(c.min && c.max) && <span> - {c.min} to {c.max}</span>}
                            {(c.minCaption && c.maxCaption) && <span> - {c.minCaption} / {c.maxCaption}</span>}
                        </li> ))}
                    </div>
                    :
                    ''
                }
            </div>
        );
    }
}

export default SequencesMonitor;